import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  IDefaultUser,
  IUserConfirmation,
  IUserConfirmationV3,
  IUserV3,
} from '../models/users.interface';

import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ServiceResponse } from '@literax/interfaces/service-response';
import { IPatch } from '@literax/models/http/api/client/client.model';
import { IColumnSorting, IFilterField } from '@literax/models/pagination.model';
import { BaseService } from '@literax/services/base-config/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UsersServices {
  uri = environment.apiEndpoint + '/' + environment.apiVersion;
  uriV3 = environment.apiEndpointMigr + '/' + environment.apiVersionMigr;

  constructor(private base: BaseService, private http: HttpClient) {}

  getDashboardV3(): Observable<ServiceResponse> {
    return this.base.getObserveResponse(`/statistics/user_processes`);
  }

  getAllV3(
    pageNumber: number,
    pageSize: number,
    sortField: IColumnSorting,
    filterFields: IFilterField[]
  ): Observable<ServiceResponse> {
    let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}`;

    if (sortField) {
      queryParams += `&sortField[name]=${sortField.name}&sortField[type]=${sortField.type}`;
    }

    if (filterFields) {
      queryParams += this.base.generateFilterFields(filterFields);
    }
    return this.base.getObserveResponse(`/clientusers${queryParams}`);
  }

  saveV3(client_user: IUserV3): Observable<ServiceResponse> {
    return this.base.post(`/clientusers`, client_user, {}, true);
  }

  updateV3(
    clientUserId: number,
    patchOperations: IPatch[]
  ): Observable<ServiceResponse> {
    return this.base.patch(
      `/clientusers/${clientUserId}`,
      patchOperations,
      {
        headers: { 'Content-Type': 'application/json-patch+json' },
      },
      true
    );
  }

  deleteV3(userId: number) {
    return this.base.delete(`/clientusers/` + userId, {}, true);
  }

  userConfirm(user: IUserConfirmation, token: string) {
    const header = new HttpHeaders({
      'content-type': 'application/json',
      locale: JSON.parse(localStorage.getItem('config')).lang,
      usertoken: token,
    });
    return this.http.post(this.uri + `/users`, { user }, { headers: header });
  }

  userConfirmV3(user: IUserConfirmationV3, token: string) {
    const header = new HttpHeaders({
      'content-type': 'application/json',
      locale: JSON.parse(localStorage.getItem('config')).lang,
      usertoken: token,
    });
    return this.http.post(this.uriV3 + `/users`, user, { headers: header });
  }

  userLoginConfirm(
    token: string,
    b2cToken: string
  ): Observable<ServiceResponse> {
    const body = { join_with_current_user: true };
    return this.http.post<ServiceResponse>(this.uri + `/users`, body, {
      headers: { usertoken: token, Authorization: `bearer ${b2cToken}` },
    });
  }

  info = (email: string): Observable<ServiceResponse> =>
    this.base.get(`/users/${email}/info`, new HttpParams(), true);

  getUserProfiles(): Observable<ServiceResponse> {
    return this.base.get(`/profiles`);
  }

  getReceivers = (
    excludeOneself: boolean = false
  ): Observable<ServiceResponse> =>
    this.base.get(
      `/departments/receivers?excludeOneself=${excludeOneself}`,
      new HttpParams(),
      true
    );

  setDefaultUser(defaultUser: IDefaultUser): Observable<ServiceResponse> {
    return this.base.put(`/client_users/set_default/` + defaultUser.uuid, {
      client_user: { is_default: defaultUser.is_default },
    });
  }

  disableTaxMessage(): Observable<ServiceResponse> {
    return this.base.put(`/users`, {
      user: {
        disable_tax_validation: true,
      },
    });
  }
}
